<tup-mat-content-wrapper position="first">
  <tup-mat-title-bar title="{{ api?.label }}"></tup-mat-title-bar>
</tup-mat-content-wrapper>

<tup-mat-content-wrapper position="middle">
  <button mat-button (click)="scrollToDocSection()">
    <mat-icon>arrow_downward</mat-icon>
    Jump to documentation
  </button>
</tup-mat-content-wrapper>

<tup-mat-content-wrapper position="middle">
  <div *ngIf="workInProgress">Loading...</div>
  <div #swaggerUi></div>
  <div class="error-message-panel" *ngIf="errorMessage && !workInProgress">
    {{ errorMessage }}
  </div>
</tup-mat-content-wrapper>

<tup-mat-content-wrapper position="last" class="dev-doc-content">
  <div #docContentAnchor>&nbsp;</div>
  <h2>Developer's Documentation</h2>
  <div markdown
    [data]="dev_doc"
    (error)="onMarkdownError($event)"
  ></div>
</tup-mat-content-wrapper>
